module.exports = __webpack_public_path__ + "static/media/parken-logo.77101fce.png";